import { FC } from 'react';
import { Container } from './components';

interface RefusedProps {
  interview?: any;
}

const Refused: FC<RefusedProps> = ({ interview }) => {
  const isMenteeProposal = String(interview?.authorId) === String(interview?.mentorship?.menteeId);
  const menteeName = interview?.mentorship?.mentee?.firstName || 'Le mentoré';
  const mentorName = interview?.mentorship?.mentor?.firstName || 'Le mentor';

  return (
    <Container>
      <p>
        {isMenteeProposal 
          ? `${mentorName} a refusé la proposition faite par ${menteeName}.`
          : `${menteeName} a refusé la proposition faite par ${mentorName}.`}
      </p>
    </Container>
  );
};

export default Refused;